import { client } from '../http';

export default {
  async generateCode({ phoneNumber }) {
    return await client.post('/api/no-auth/signup/generate-code', { phoneNumber });
  },
  async valideateCode({ phoneNumber, code }) {
    return await client.post('/api/no-auth/signup/validate-code', { phoneNumber, code });
  },
  async createMemberUsingCode({ firstName, lastName, phoneNumber, code }) {
    return await client.post('/api/invite-auth/signup/create-member', { firstName, lastName, phoneNumber, code });
  },
  async createCustomer({
    firstName, lastName, utmParams,
  }) {
    return await client.post('/api/code-auth/signup/create-customer-and-token', {
      firstName,
      lastName,
      utmParams,
    });
  },
  async saveCustomerAnswers(answers) {
    return await client.post('/api/signup/save-lead-qualification-answers', {
      answers,
    });
  },
  async sendBotiIntro() {
    return await client.post('/api/signup/send-boti-intro');
  },
  async sendNewValidLink() {
    return await client.post('/api/code-auth/signup/send-new-valid-link');
  },
};



// WEBPACK FOOTER //
// ./src/api/SignupApi.js